var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.loading
    ? _c("div", { staticClass: "loading-container" }, [
        _c("div", { staticClass: "item" }, [
          _c("i", { staticClass: "loader", class: "--" + _vm.loadingElement }),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }